import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['icon'];
  static values = {
    favoritableType: String,
    favoritableId: String,
    favoriteId: String,
    favoriteText: String,
    unfavoriteText: String
  }

  connect() {
    this.element.addEventListener('click', this.toggleFavorite.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('click', this.toggleFavorite.bind(this));
  }

  toggleFavorite(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const method = this.favoriteIdValue ? 'DELETE' : 'POST';
    const url = this.favoriteIdValue
      ? `/admin/favorites/${this.favoriteIdValue}`
      : '/admin/favorites';

    const formData = new FormData();
    formData.append('favoritable_id', this.favoritableIdValue);
    formData.append('favoritable_type', this.favoritableTypeValue);

    Rails.ajax({
      url: url,
      type: method,
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false,
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      },
      success: (data) => {
        if (data.status === 'success') {
          this._updateFavoriteState(data.favorited, data.favorite_id);
          this._dispatchFavoriteChangedEvent(data.favorited, data.favorite_id);
        }
      }
    });
  }

  _updateFavoriteState(isFavorited, favoriteId) {
    // Update favorite ID for future delete requests
    if (isFavorited && favoriteId) {
      this.favoriteIdValue = favoriteId;
    } else if (!isFavorited) {
      this.favoriteIdValue = '';
    }

    // Update icon by replacing the entire icon span content
    const iconElement = this.iconTarget;
    const newIcon = isFavorited ? 'star-filled' : 'star';

    iconElement.setAttribute('data-test-icon', newIcon);

    // Update SVG path element directly
    const svgElement = iconElement.querySelector('svg');
    if (svgElement) {
      const pathElement = svgElement.querySelector('path');
      if (pathElement) {
        if (isFavorited) {
          // Filled star with purple color
          pathElement.setAttribute('fill', '#832088');
        } else {
          pathElement.removeAttribute('fill');
        }
      }
    }

    // Update title / tooltip
    this.element.setAttribute(
      'title', isFavorited ? this.unfavoriteTextValue : this.favoriteTextValue
    );
  }

  _dispatchFavoriteChangedEvent(favorited, favoriteId) {
    const event = new CustomEvent('promote:favorites-changed', {
      detail: {
        favorited: favorited,
        favoritable_id: this.favoritableIdValue,
        favorite_id: favoriteId
      },
      bubbles: true
    });

    this.element.dispatchEvent(event);
  }
}
